// import React from "react";
// import { Card } from 'primereact/card';
// import { PiCity } from "react-icons/pi";
// import { MdAccountBalance, MdFormatListBulleted, MdOutlineHolidayVillage } from "react-icons/md";
// import { useNavigate } from "react-router-dom";

// // Reusable Setting Card component
// const SettingCard = ({ icon: Icon, label, to }: { icon: React.ComponentType, label: string, to: string }) => {
//     const navigate = useNavigate();

//     const handleCardClick = () => {
//         navigate(to);
//     };

//     return (
//         <div className="card" onClick={handleCardClick}>
//             <Card className="cursor-pointer">
//                 <div className="flex items-center">
//                     <Icon />
//                     <span className="ml-2 text-primary font-bold">{label}</span>
//                 </div>
//             </Card>
//         </div>
//     );
// };

// const LiveSupportPage: React.FC = () => {
//     const settingsData = [
//         { icon: MdAccountBalance, label: "Country", to: "/admin/country" },
//         { icon: MdAccountBalance, label: "State", to: "/admin/state" },
//         { icon: PiCity, label: "District", to: "/admin/district" },
//         { icon: PiCity, label: "Taluka", to: "/admin/taluka" },
//         { icon: MdOutlineHolidayVillage, label: "Village", to: "/admin/village" },
//         { icon: MdFormatListBulleted, label: "Sub Cast", to: "/admin/subcast" },
//         { icon: MdFormatListBulleted, label: "Surnames", to: "/admin/surnames" },
//         { icon: MdFormatListBulleted, label: "Registration Document", to: "/admin/registrationdoc" },
//         { icon: MdAccountBalance, label: "Business Type", to: "/admin/businesstype" },
//         { icon: MdAccountBalance, label: "Business Category", to: "/admin/businesscategory" },
//         { icon: MdAccountBalance, label: "Registration Type", to: "/admin/registrationtype" },
//         { icon: MdAccountBalance, label: "Product Type", to: "/admin/producttype" },
//         { icon: MdAccountBalance, label: "Business Member Tag", to: "/admin/businessmemtag" },
//         { icon: MdFormatListBulleted, label: "Bazar Products", to: "/admin/bazarproducts" },
//         { icon: MdFormatListBulleted, label: "Bazar Bhav", to: "/admin/bazarbhav" }
//     ];

//     return (
//         <div className="dashboard-margin flex gap-2 flex-wrap">
//             {settingsData.map((setting, index) => (
//                 <SettingCard
//                     key={index}
//                     icon={setting.icon}
//                     label={setting.label}
//                     to={setting.to} // Passing the `to` prop to the SettingCard
//                 />
//             ))}
//         </div>
//     );
// };

// export default LiveSupportPage;
import React, { useEffect, useState } from "react";
import Sidebar from "./views/Sidebar";
import ChatWindow from "./views/ChatWindow";
import RightPanel from "./views/RightPanel";
import userlogo from "../../assets/images/user.jpg";

interface Chat {
    id: string;
    name: string;
    image: string;
    lastmessage: string;
    messages: { id: string; text: string; sender: string; timestamp: string }[];
}

const LiveSupportPage: React.FC = () => {
    const [chats, setChats] = useState<Chat[]>([
        {
            id: "q",
            name: "Jayesh Trivedi",
            image: userlogo,
            lastmessage: "Hi",
            messages: [
                {
                    id: "1",
                    text: "hi",
                    sender: "QA",
                    timestamp: "11/11/2024, 2:49:13 PM",
                },
                {
                    id: "2",
                    text: "Hello",
                    sender: "You",
                    timestamp: "11/11/2024, 2:55:47 PM",
                },
            ],
        },
        {
            id: "b",
            name: "Jay Vaghela",
            image: userlogo,
            lastmessage: "can you help me?",
            messages: [],
        },
        {
            id: "u",
            name: "Rohit Samnani",
            image: userlogo,
            lastmessage: "for inquiry",
            messages: [],
        },
    ]);
    const [activeChat, setActiveChat] = useState<Chat | null>(chats[0]);

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [mobileView, setMobileView] = useState<"list" | "chat" | "info">("list");

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleSelectChat = (chat: Chat) => {
        setActiveChat(chat);
        setMobileView("chat");
    };

    const handleSend = (message: string) => {
        if (activeChat) {
            const newMessage = {
                id: Date.now().toString(),
                text: message,
                sender: "You",
                timestamp: new Date().toLocaleString(),
            };
            setChats((prevChats) =>
                prevChats.map((chat) =>
                    chat.id === activeChat.id
                        ? { ...chat, messages: [...chat.messages, newMessage] }
                        : chat
                )
            );
        }
    };

    return (
        <div className="chat-layout">
            <div className="flex layout-window">
                {(!isMobile || mobileView === "list") && (
                    <Sidebar
                        chats={chats}
                        activeChat={activeChat}
                        setActiveChat={handleSelectChat}
                        isMobile={isMobile}
                    />
                )}
                {(!isMobile || mobileView === "chat") && (
                    <ChatWindow
                        chat={activeChat}
                        onSend={handleSend}
                        isMobile={isMobile}
                        onBack={() => setMobileView("list")}
                        onInfo={() => setMobileView("info")}
                    />
                )}
                {(!isMobile || mobileView === "info") && (
                    <RightPanel
                        chat={activeChat}
                        isMobile={isMobile}
                        onBack={() => setMobileView("chat")}
                    />
                )}
            </div>
        </div>
    );
};

export default LiveSupportPage;
